import React from 'react';
import { Tooltip, IconButton, Theme, keyframes, useTheme } from '@mui/material';
import { useState } from 'react';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { useTranslation } from 'react-i18next';

interface FavouriteIconButtonProps {
    isFavourited: boolean;
    onAddFavouriteBtnClick: () => void;
    onRemoveFavouriteBtnClick?: () => void;
}

// Define the keyframes for the flashing animation
const flashAnimation = (theme: Theme) => keyframes`
  0% { color: ${theme.palette.action.disabled}; }
  50% { color: ${theme.palette.primary.main}; }
  100% { color: ${theme.palette.action.disabled}; }
`;


export const FavouriteIconButton = ({ isFavourited, onRemoveFavouriteBtnClick, onAddFavouriteBtnClick }: FavouriteIconButtonProps) => {
	const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.preventDefault();
		e.stopPropagation();
		if (!isFavourited) {
			onAddFavouriteBtnClick();
		} else if (onRemoveFavouriteBtnClick) {
			onRemoveFavouriteBtnClick();
		}
	};
	return (
		<IconButton
			sx={{ color: 'rgba(255, 255, 255, 0.54)', mt:1}}
			onClick={(e) => handleClick(e)}
		>
			{isFavourited ? <FavoriteIcon color='primary' /> : <FavoriteBorderIcon color='disabled' />}
		</IconButton>);
};	

export const FlashingFavouriteIconButtonWithRegisterTooltip = ({ size = 'large', onClick }: { size?: 'large' | 'small', onClick?: () => void }) => {
	const theme = useTheme();
	const [isFlashing, setIsFlashing] = useState(false);
	const { t } = useTranslation();
	const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.stopPropagation();
		e.preventDefault();
		if (!isFlashing) {
			setIsFlashing(true);
			setTimeout(() => setIsFlashing(false), 2000);
		}
		if (onClick) {
			onClick();
		}
	};
	return (
		<Tooltip 
			title={t('common.savedTooltip')} 
			placement="top"
			enterTouchDelay={0}
			leaveTouchDelay={1500}
		>
			<IconButton
				sx={{ color: 'rgba(255, 255, 255, 0.54)'}}
				onClick={(e) => handleClick(e)}
				size={size}
			>
				<FavoriteBorderIcon color='disabled' sx={isFlashing ? {animation: `${flashAnimation(theme)} 1s step-start 2`} : {}} />
			</IconButton>
		</Tooltip>
	);
};